import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { AgreementRecord } from '../entities/records';
import * as selectors from '../entities/Agreement/selectors';

function mapStateToProps(state, { agreementId }) {
  return {
    agreement: selectors.agreementById(state, agreementId),
  };
}

export default compose(
  setPropTypes({
    agreementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    agreement: PropTypes.instanceOf(AgreementRecord),
  }),
)(mapStateToProps);
